import { useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import getXcolumnJson from "./xcolumn/list";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import SearchArea from "./area/search";
import ReportListExcelDown from "./area/excel_down";

const ReportList = forwardRef((props: any, ref) => {
  let myProps = {
    stu_list: (inData: any) => { },
    ...props
  };

  const xColumnArr = getXcolumnJson();
  let select_stu_grade_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade2' });
  const listAggridRef = useRef<any>();
  const ReportListExcelDownRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_start_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "s_end_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "s_stu_seq": [],
    "s_writer_seq": "",
    "s_subject": "",
    "s_addon_user": "1",
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [teacher_arr, set_teacher_arr] = useState([]);

  useEffect(() => {
    get_teacher_list();
  }, []);

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    list
  }));

  const list = (inData: any) => {
    let change_list_opt={
      ...listOpt,
      ...inData
    };
    change_list_opt["sc"]=listAggridRef.current.getListSc();
    setListOpt(change_list_opt);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/prescribe/daily_prescribe/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_teacher_list = () => {
    let teacher_list_form_json = {
      "s_is_login": "1",
      "s_grade": ["teacher", "master", "staff"],
      "order_id": "a_user_name",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', teacher_list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_teacher_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const goDelete = (e: any) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/prescribe/daily_prescribe/delete', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_excel_down = () => {
    if (ReportListExcelDownRef.current) {
      ReportListExcelDownRef.current.goExcelDown();
    }
  };

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;

    if (key == "a_stu_name") {
      if (params.data.stu_info) {
        let tmp_stu_grade = "";
        for (let i = 0; i < select_stu_grade_arr.length; i++) {
          if (select_stu_grade_arr[i]["value"] == params.data.stu_info["a_stu_grade"]) {
            tmp_stu_grade = select_stu_grade_arr[i]["text"];
          }
        }
        render_str = render_str + " " + tmp_stu_grade;
      }
    }
    let text_area_key_arr=[
      "a_issue","a_homework_plan","a_homework_amount",
      "a_progress_plan","a_progress_amount","a_memo"
    ];
    if(strFunc.str_in_array(key,text_area_key_arr)!=-1){
      render_str=(
        <MultyLineTextView text={render_str}  />
      );
    }

    return render_str;
  }, []);

  return (
    <div>
      <div className="relative" style={{ minHeight: 57 }}>
        <SearchArea
          xColumnArr={xColumnArr}
          listOpt={listOpt}
          list={list}
          stu_list={myProps.stu_list}
          goDelete={goDelete}
          go_excel_down={go_excel_down}
          teacher_arr={teacher_arr}
        ></SearchArea>
      </div>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: true,
          floatingFilter: true,
          col_autoHeight: true,
          rowMultiSelectWithClick: true,
          onGridReady: () => {
            list({});
          },
          cellRenderer: cellRenderer,
        }}
      ></ListAggrid>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      <ReportListExcelDown
        ref={ReportListExcelDownRef}
        xColumnArr={xColumnArr}
        infoArr={infoArr}
      ></ReportListExcelDown>
    </div>
  );
});
export default ReportList;